import React from "react";
import styled from "styled-components";

const Container = styled.section`
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  backdrop-filter: blur(8px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  color: white;
  max-width: 1280px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.greenLight || "#90EE90"};
  text-align: center;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    font-size: 3.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.blue8 || "#a8c4f0"};
  text-align: center;
  margin-bottom: 3rem;

  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`;

const Grid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: row;
  background: ${({ theme }) => theme.gray26 || "#1e2a3c"};
  padding: 1.5rem;
  border-radius: 1rem;
  align-items: center;
  gap: 1.5rem;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.03);
    background: ${({ theme }) => theme.gray30 || "#27364a"};
  }

  @media (max-width: 500px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Icon = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardTitle = styled.h3`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.text || "#ffffff"};
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const CardDesc = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.text || "#d0d6e0"};

  @media (min-width: 768px) {
    font-size: 1.05rem;
  }
`;

const features = [
  {
    icon: "/assets/img/PNG/fast_payment_pic.png",
    title: "Fast Payment",
    desc: "Complete unlimited transactions in under a minute with MitterPay.",
  },
  {
    icon: "/assets/img/PNG/bulk_payment_logo.png",
    title: "Bulk Payment",
    desc: "Send mass payments to your entire organization with a single click.",
  },
  {
    icon: "/assets/img/PNG/team_org_pic.png",
    title: "Team Organization",
    desc: "Group recipients into teams for streamlined future payments.",
  },
  {
    icon: "/assets/img/PNG/Cheap_trans_fee_pic.png",
    title: "Cheap Transaction Fees",
    desc: "Enjoy the lowest transaction costs—efficiency meets affordability.",
  },
];

const Features = () => (
  <Container id="features">
    <Title>Features</Title>
    <Subtitle>Why Individuals and Businesses Prefer MitterPay</Subtitle>
    <Grid>
      {features.map(({ icon, title, desc }) => (
        <Card key={title}>
          <Icon src={icon} alt={title} />
          <TextBlock>
            <CardTitle>{title}</CardTitle>
            <CardDesc>{desc}</CardDesc>
          </TextBlock>
        </Card>
      ))}
    </Grid>
  </Container>
);

export default Features;
